export const types = {
  GET_EXTRA_APPOINTMENT_OPTIONS: 'APPOINTMENT/GET_EXTRA_APPOINTMENT_OPTIONS',
  GET_EXTRA_APPOINTMENT_OPTIONS_SUCCESS:
    'APPOINTMENT/GET_EXTRA_APPOINTMENT_OPTIONS_SUCCESS',
  GET_EXTRA_APPOINTMENT_OPTIONS_BEGIN:
    'APPOINTMENT/GET_EXTRA_APPOINTMENT_OPTIONS_BEGIN',
  GET_EXTRA_APPOINTMENT_OPTIONS_FAIL:
    'APPOINTMENT/GET_EXTRA_APPOINTMENT_OPTIONS_FAIL',
  SET_APPOINTMENT_TEXT: 'APPOINTMENT/SET_APPOINTMENT_TEXT',
};
export const actions = {
  getExtraAppointmentOptions: (data) => ({
    type: types.GET_EXTRA_APPOINTMENT_OPTIONS,
    payload: { data },
  }),
  getExtraAppointmentOptionsSuccess: (data) => ({
    type: types.GET_EXTRA_APPOINTMENT_OPTIONS_SUCCESS,
    payload: { data },
  }),
  getExtraAppointmentOptionsBegin: () => ({
    type: types.GET_EXTRA_APPOINTMENT_OPTIONS_BEGIN,
  }),
  getExtraAppointmentOptionsFail: () => ({
    type: types.GET_EXTRA_APPOINTMENT_OPTIONS_FAIL,
  }),
  setAppointmentText: (data) => ({
    type: types.SET_APPOINTMENT_TEXT,
    payload: { data },
  }),
};
const initialState = {
  firstAvailableAppointment: null,
  appointmentOptions: null,
  disabledDays: null,
  getExtraAppointmentLoading: false,
  getExtraAppointmentFail: false,
  appointmentText: '',
  manualAppointmentText: '',
};
function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.GET_EXTRA_APPOINTMENT_OPTIONS: {
      const { data } = { ...action.payload };
      const { firstAvailableAppointment } = { ...data };
      return {
        ...state,
        appointmentOptions: null,
        firstAvailableAppointment,
        getExtraAppointmentLoading: true,
        getExtraAppointmentFail: false,
      };
    }
    case types.GET_EXTRA_APPOINTMENT_OPTIONS_BEGIN: {
      return {
        ...state,
        getExtraAppointmentLoading: true,
        getExtraAppointmentFail: false,
      };
    }
    case types.GET_EXTRA_APPOINTMENT_OPTIONS_SUCCESS: {
      const { data } = { ...action.payload };
      const { appointmentOptions, disabledDays, firstAvailableAppointment } = {
        ...data,
      };
      return {
        ...state,
        firstAvailableAppointment:
          firstAvailableAppointment || state.firstAvailableAppointment,
        appointmentOptions: appointmentOptions || null,
        getExtraAppointmentLoading: false,
        getExtraAppointmentFail: false,
        disabledDays,
      };
    }
    case types.GET_EXTRA_APPOINTMENT_OPTIONS_FAIL: {
      return {
        ...state,
        getExtraAppointmentLoading: false,
        getExtraAppointmentFail: true,
      };
    }
    case types.SET_APPOINTMENT_TEXT: {
      const { data } = { ...action.payload };
      const { appointmentText, manualAppointmentText } = { ...data };
      return {
        ...state,
        appointmentText,
        manualAppointmentText,
      };
    }
    default:
      return state;
  }
}
export default reducer;
